/* unplugin-vue-components disabled */import { render } from "./Promocode.vue?vue&type=template&id=8034afc8&scoped=true&ts=true"
import script from "./Promocode.vue?vue&type=script&lang=ts"
export * from "./Promocode.vue?vue&type=script&lang=ts"

import "./Promocode.vue?vue&type=style&index=0&id=8034afc8&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8034afc8"]])

export default __exports__